<template>
  <div :class="'w-' + width +  ' h-' + height" @click="$emit('click')">
    <img :class="imgClass" v-if="user.avatar" :src="user.avatar" :alt="user.username" />
    <img :class="imgClass" v-else src="@/assets/avatar.png" :alt="user.username" />
  </div>
</template>

<script>
export default {
  name: "Avatar",
  props: {
    user: {
      required: true
    },
    size: {
      default: 8
    },
    color: {
      default: null
    },
    channel: {
      default: null
    }
  },
  computed: {
    borderColor() {
      if (this.color !== null) return this.color
      if (this.user.role === "admin") return "blue-7"
      if (this.user.role === "super-moderator") return "yellow-7"
      if (
        this.$route.params.channel !== null &&
        this.user.moderatable_channels.indexOf(this.$route.params.channel) !== -1
      )
        return "orange-7"
      return "grey-7"
    },
    imgClass() {
      return (
        "w-full h-full border-2 border-" +
        this.borderColor +
        " rounded-full  bg-black"
      )
    },
    width() {
      return this.size
    },
    height() {
      if (this.size === "full") return "auto"
      return this.size
    }
  }
}
</script>

<style scoped lang="scss">
</style>
